import { FC } from 'react';
import { SpaceNodeKind } from 'shared';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { DataRoomModalType } from '../../enums/data-room-modal-type.enum';
import { useDeleteSpaceNode } from '../../hooks/use-delete-space-node.hook';
import { DataRoomModalStore } from '../../store/data-room-modal.store';
import { ConfirmDeleteModal } from './confirm-delete-modal';

export const DeleteSpaceNodeModal: FC = () => {
  const isOpen = DataRoomModalStore(({ isOpen }) => isOpen);
  const type = DataRoomModalStore(({ type }) => type);
  const metadata = DataRoomModalStore(({ metadata }) => metadata);
  const handleAccept = DataRoomModalStore(({ handleAccept }) => handleAccept);
  const handleDismiss = DataRoomModalStore(({ handleDismiss }) => handleDismiss);
  const { deleteNode, isPending } = useDeleteSpaceNode({ onSuccess: handleAccept });

  const node = metadata?.node;

  if (type !== DataRoomModalType.DELETE_SPACE_NODE || !metadata || !node) {
    return null;
  }

  const isFolder = node.kind === SpaceNodeKind.FOLDER;

  return (
    <ConfirmDeleteModal
      body={
        // A folder says what goes with it; a file asks once more, by its name.
        <AppFormattedMessage
          id={isFolder ? 'DELETE_SPACE_FOLDER_CONFIRMATION' : 'DELETE_SPACE_FILE_CONFIRMATION'}
          values={{ name: node.name }}
        />
      }
      isOpen={isOpen}
      isPending={isPending}
      onCancel={handleDismiss}
      onConfirm={() =>
        deleteNode({
          id: node.id,
          kind: node.kind,
          space: { id: metadata.spaceId, kind: node.spaceKind },
        })
      }
      title={<AppFormattedMessage id={isFolder ? 'DELETE_SPACE_FOLDER' : 'DELETE_SPACE_FILE'} />}
    />
  );
};
